<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#322A37" opacity="1.000000" stroke="none" 
	d="
M382.000000,266.000000 
	C381.250000,266.000000 380.500000,266.000000 379.141174,265.735260 
	C377.021545,265.647003 375.510773,265.823517 374.000000,266.000000 
	C297.979095,266.000000 221.958206,266.000000 145.379791,265.835327 
	C144.548157,265.780426 144.274078,265.890198 144.000000,266.000000 
	C102.979103,266.000000 61.958210,266.000000 20.478088,265.680511 
	C19.340353,264.592773 18.661846,263.824493 18.145401,262.677063 
	C19.094395,258.086853 20.238216,253.956299 16.795784,250.107040 
	C15.636778,248.811050 15.059214,246.535187 15.078044,244.716110 
	C15.290481,224.194016 15.626166,203.672791 16.041372,183.153595 
	C16.131584,178.695297 17.015863,174.235931 16.886578,169.795914 
	C16.787762,166.402298 15.059471,163.023819 15.140479,159.664749 
	C15.266898,154.422745 16.401964,149.212280 16.947584,143.971573 
	C17.933052,134.506134 14.972694,125.620796 12.661002,116.661896 
	C11.987910,114.053345 10.897784,111.552406 10.467610,109.001251 
	C138.551376,109.000351 266.166351,109.004936 393.781342,108.959702 
	C395.847961,108.958969 397.914429,108.349342 400.235718,108.018341 
	C400.660370,108.008545 400.830200,108.004272 401.000000,108.000000 
	C401.000000,153.687561 401.000000,199.375122 400.641541,245.548462 
	C396.310059,254.348328 390.620453,261.020660 382.153931,265.062012 
	C381.990601,265.139984 382.046417,265.677124 382.000000,266.000000 
M39.907238,154.001038 
	C84.275024,153.991623 128.642838,153.999069 173.010483,153.917053 
	C174.985626,153.913406 176.959259,153.095627 179.398346,152.161484 
	C185.860580,147.819000 186.117630,139.517670 179.866196,133.496017 
	C179.238129,132.990860 178.610046,132.485687 177.388123,131.401077 
	C176.411301,131.267609 175.434509,131.017807 174.457642,131.017380 
	C130.036148,130.998077 85.614647,130.991638 41.193211,131.042130 
	C39.795578,131.043716 38.398636,131.659119 37.012272,132.655487 
	C37.006996,133.099731 37.001720,133.543976 36.610291,134.569138 
	C29.665400,139.109833 29.877460,147.498428 37.261162,153.034164 
	C37.522182,153.386505 37.783207,153.738831 38.215511,154.385010 
	C38.466316,154.279053 38.717125,154.173096 39.907238,154.001038 
M357.371124,131.391205 
	C356.727661,131.263733 356.084351,131.025513 355.440735,131.024872 
	C333.865509,131.003036 312.290253,130.988205 290.715118,131.041946 
	C289.479950,131.045013 288.246216,131.634796 287.007599,132.611618 
	C286.999176,133.051010 286.990753,133.490417 286.582123,134.463028 
	C284.962097,135.985260 283.342102,137.507492 280.991486,139.294189 
	C280.665314,139.997696 280.057098,140.700134 280.054443,141.404861 
	C279.997375,156.475143 279.965851,171.546005 280.084625,186.615524 
	C280.094330,187.849121 281.218048,189.073929 282.280914,190.511978 
	C283.415436,191.805893 284.549957,193.099808 286.009888,194.990204 
	C286.674744,194.988037 287.339569,194.985870 288.928864,194.820648 
	C311.953949,194.885269 334.979034,194.949890 358.446350,195.575058 
	C359.419708,195.183395 360.393066,194.791718 361.565430,193.890778 
	C362.713440,192.594711 363.861450,191.298645 365.785004,189.772659 
	C366.181030,189.110703 366.919861,188.450302 366.922882,187.786575 
	C366.992279,172.495392 367.017242,157.203598 366.902435,141.913025 
	C366.895050,140.933914 365.690216,139.963791 364.504242,138.604980 
	C363.002563,137.071304 361.500885,135.537613 359.875275,133.363220 
	C359.237885,132.897202 358.600494,132.431168 357.371124,131.391205 
M72.185989,188.719284 
	C76.706200,185.379059 76.886665,180.596481 75.062531,176.216217 
	C74.152191,174.030228 70.838249,171.604507 68.490707,171.474884 
	C58.891697,170.944794 49.244537,171.156250 39.618351,171.304779 
	C34.964592,171.376587 32.338085,174.149399 31.844290,178.709686 
	C31.284664,183.877914 32.814907,187.847763 38.158390,190.652924 
	C38.787170,191.087296 39.412144,191.893539 40.045319,191.900024 
	C48.918663,191.990982 57.793854,192.023056 66.666069,191.894821 
	C67.453613,191.883423 68.223572,190.655624 69.421310,189.681610 
	C69.592583,189.713058 69.763863,189.744492 70.288078,190.313889 
	C70.791878,189.950485 71.295670,189.587082 72.185989,188.719284 
M100.572868,170.487534 
	C99.769157,170.896362 98.965454,171.305176 97.759354,172.214478 
	C91.120865,178.428284 92.588951,186.484894 101.194733,190.777618 
	C101.692024,191.156479 102.185944,191.860657 102.687096,191.865845 
	C111.326744,191.955124 119.967987,192.010529 128.606461,191.894058 
	C129.412598,191.883194 130.202454,190.665497 131.588623,189.612289 
	C139.694595,186.538467 140.839783,178.504929 133.928085,171.046066 
	C133.277634,171.066544 132.627182,171.087021 131.051178,171.246964 
	C121.036064,171.173553 111.020943,171.100128 100.572868,170.487534 
z"/>
<path fill="#312936" opacity="1.000000" stroke="none" 
	d="
M20.000000,1.000000 
	C140.354233,1.000000 260.708466,1.000000 381.544800,1.352290 
	C386.705048,5.671570 391.557587,9.455984 395.984802,13.685555 
	C398.076630,15.683982 399.353760,18.535179 401.000000,20.999996 
	C401.000000,32.354229 401.000000,43.708454 400.740295,55.512543 
	C400.307434,55.949966 400.134277,55.937538 399.873779,55.775982 
	C399.531769,55.736748 399.277069,55.846638 398.642120,55.972584 
	C397.500793,55.982121 396.739716,55.975609 395.680542,55.681877 
	C393.904327,55.263008 392.426300,55.016281 390.948212,55.016075 
	C264.371643,54.998417 137.795090,54.995941 11.218546,55.040237 
	C9.484647,55.040844 7.750960,55.648132 5.680441,55.985329 
	C4.894427,55.995731 4.445147,55.993073 3.909804,55.829369 
	C3.555812,55.767040 3.287882,55.865753 2.812348,56.054192 
	C2.333618,56.314133 2.168256,56.556499 1.831807,56.905956 
	C1.369971,56.960598 1.184985,56.980297 1.000000,57.000000 
	C1.000000,45.312439 1.000000,33.624878 1.358933,21.453426 
	C5.805338,13.202936 10.482222,6.012413 19.213528,2.656298 
	C19.626835,2.497433 19.744600,1.569679 20.000000,1.000000 
z"/>
<path fill="#EEC67A" opacity="1.000000" stroke="none" 
	d="
M401.000000,59.000000 
	C401.000000,73.687561 401.000000,88.375122 400.533966,103.531960 
	C267.386658,103.989754 134.705383,103.978279 2.014610,103.501595 
	C2.003714,90.715836 1.998452,78.395279 2.002420,66.074722 
	C2.004696,59.007236 2.011441,59.004147 8.905744,59.004051 
	C139.603836,59.002232 270.301910,59.001194 401.000000,59.000000 
z"/>
<path fill="#322832" opacity="1.000000" stroke="none" 
	d="
M9.998818,109.002136 
	C10.897784,111.552406 11.987910,114.053345 12.661002,116.661896 
	C14.972694,125.620796 17.933052,134.506134 16.947584,143.971573 
	C16.401964,149.212280 15.266898,154.422745 15.140479,159.664749 
	C15.059471,163.023819 16.787762,166.402298 16.886578,169.795914 
	C17.015863,174.235931 16.131584,178.695297 16.041372,183.153595 
	C15.626166,203.672791 15.290481,224.194016 15.078044,244.716110 
	C15.059214,246.535187 15.636778,248.811050 16.795784,250.107040 
	C20.238216,253.956299 19.094395,258.086853 17.792492,262.626160 
	C10.749238,260.324921 6.334668,255.676285 3.900132,248.830872 
	C3.634048,248.337173 3.393202,248.145020 3.020791,247.708191 
	C2.304681,246.919006 1.652339,246.459503 0.999999,246.000000 
	C1.000000,245.250000 1.000000,244.500000 1.214571,243.254059 
	C1.711172,242.565964 1.907142,242.308350 2.306849,241.688156 
	C2.731174,239.580109 2.982219,237.769226 2.983143,235.958206 
	C3.004736,193.642624 2.999274,151.327011 3.436331,109.008438 
	C5.915516,109.004349 7.957167,109.003242 9.998818,109.002136 
z"/>
<path fill="#ECC789" opacity="1.000000" stroke="none" 
	d="
M2.024113,103.966797 
	C134.705383,103.978279 267.386658,103.989754 400.533966,104.000618 
	C401.000000,104.000000 401.000000,104.500000 400.824463,104.837311 
	C400.587708,105.289001 400.446930,105.466637 400.478943,105.506943 
	C400.626251,105.692245 400.821777,105.839249 401.000000,105.999992 
	C401.000000,106.000000 401.000000,106.500000 400.567017,106.551163 
	C398.803040,106.563728 397.471985,106.491394 396.140961,106.491325 
	C266.066833,106.484276 135.992706,106.480812 5.918582,106.502335 
	C4.279027,106.502602 2.639526,106.826927 1.000000,107.000000 
	C1.000000,107.000000 1.000000,106.500000 1.255772,106.088989 
	C1.682401,105.107582 1.853257,104.537193 2.024113,103.966797 
z"/>
<path fill="#D6BB8D" opacity="1.000000" stroke="none" 
	d="
M2.014611,103.501595 
	C1.853257,104.537193 1.682401,105.107582 1.255772,105.838989 
	C1.000000,90.312439 1.000000,74.624878 1.465057,58.464485 
	C134.953415,57.994434 267.976715,57.997215 401.000000,58.000000 
	C401.000000,58.000000 401.000000,58.500000 401.000000,58.750000 
	C270.301910,59.001194 139.603836,59.002232 8.905744,59.004051 
	C2.011441,59.004147 2.004696,59.007236 2.002420,66.074722 
	C1.998452,78.395279 2.003714,90.715836 2.014611,103.501595 
z"/>
<path fill="#795F35" opacity="1.000000" stroke="none" 
	d="
M401.000000,57.750000 
	C267.976715,57.997215 134.953415,57.994434 1.465057,57.995827 
	C1.000000,58.000000 1.000000,57.500000 1.000000,57.250000 
	C1.184985,56.980297 1.369971,56.960598 2.286442,56.960388 
	C135.678619,56.986588 268.339294,56.993294 401.000000,57.000000 
	C401.000000,57.000000 401.000000,57.500000 401.000000,57.750000 
z"/>
<path fill="#1D1429" opacity="1.000000" stroke="none" 
	d="
M1.000000,107.250000 
	C2.639526,106.826927 4.279027,106.502602 5.918582,106.502335 
	C135.992706,106.480812 266.066833,106.484276 396.140961,106.491325 
	C397.471985,106.491394 398.803040,106.563728 400.567017,106.801163 
	C401.000000,107.000000 401.000000,107.500000 401.000000,107.750000 
	C400.830200,108.004272 400.660370,108.008545 399.769501,108.008316 
	C266.698334,108.004242 134.348175,108.004662 1.748580,107.990952 
	C1.499141,107.976807 1.000000,108.000000 1.000000,108.000000 
	C1.000000,108.000000 1.000000,107.500000 1.000000,107.250000 
z"/>
<path fill="#1B0519" opacity="1.000000" stroke="none" 
	d="
M401.000000,56.750000 
	C268.339294,56.993294 135.678619,56.986588 2.563293,56.925446 
	C2.168256,56.556499 2.333618,56.314133 3.055887,56.072426 
	C3.507028,56.000931 3.995866,55.990410 3.995866,55.990410 
	C4.445147,55.993073 4.894427,55.995731 6.146892,55.994934 
	C136.626266,55.984013 266.302460,55.976555 395.978668,55.969097 
	C396.739716,55.975609 397.500793,55.982121 398.877075,55.977219 
	C399.492310,55.965801 399.961151,55.925106 399.961151,55.925106 
	C400.134277,55.937538 400.307434,55.949966 400.740295,55.981201 
	C401.000000,56.000000 401.000000,56.500000 401.000000,56.750000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M3.993168,249.047409 
	C6.334668,255.676285 10.749238,260.324921 17.630428,263.005371 
	C18.661846,263.824493 19.340353,264.592773 20.009430,265.680511 
	C13.738731,266.000000 7.477464,266.000000 1.000000,266.000000 
	C1.000000,259.647644 1.000000,253.292862 0.999999,246.469040 
	C1.652339,246.459503 2.304681,246.919006 3.091650,247.936249 
	C3.416788,248.768646 3.672418,248.953110 3.993168,249.047409 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M401.000000,20.530952 
	C399.353760,18.535179 398.076630,15.683982 395.984802,13.685555 
	C391.557587,9.455984 386.705048,5.671570 382.013489,1.352290 
	C388.261261,1.000000 394.522552,1.000000 401.000000,1.000000 
	C401.000000,7.352347 401.000000,13.707130 401.000000,20.530952 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M382.469360,266.000000 
	C382.046417,265.677124 381.990601,265.139984 382.153931,265.062012 
	C390.620453,261.020660 396.310059,254.348328 400.641541,246.017120 
	C401.000000,252.590683 401.000000,259.181366 401.000000,266.000000 
	C394.981476,266.000000 388.960114,266.000000 382.469360,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M19.530624,1.000000 
	C19.744600,1.569679 19.626835,2.497433 19.213528,2.656298 
	C10.482222,6.012413 5.805338,13.202936 1.358933,20.984770 
	C1.000000,14.409307 1.000000,7.818615 1.000000,1.000000 
	C7.018513,1.000000 13.039881,1.000000 19.530624,1.000000 
z"/>
<path fill="#48403E" opacity="1.000000" stroke="none" 
	d="
M1.000000,108.468658 
	C1.000000,108.000000 1.499141,107.976807 1.753874,108.243362 
	C2.013436,108.678200 2.018264,108.846481 2.014613,109.481857 
	C2.009773,153.961060 2.013413,197.973160 2.017053,241.985260 
	C1.907142,242.308350 1.711172,242.565964 1.214571,242.879059 
	C1.000000,198.312439 1.000000,153.624878 1.000000,108.468658 
z"/>
<path fill="#3B353F" opacity="1.000000" stroke="none" 
	d="
M374.416656,266.000000 
	C375.510773,265.823517 377.021545,265.647003 378.766174,265.735260 
	C377.611115,266.000000 376.222198,266.000000 374.416656,266.000000 
z"/>
<path fill="#D8B580" opacity="1.000000" stroke="none" 
	d="
M401.000000,105.749992 
	C400.821777,105.839249 400.626251,105.692245 400.478943,105.506943 
	C400.446930,105.466637 400.587708,105.289001 400.824463,105.087311 
	C401.000000,105.000000 401.000000,105.500000 401.000000,105.749992 
z"/>
<path fill="#3B353F" opacity="1.000000" stroke="none" 
	d="
M144.250000,266.000000 
	C144.274078,265.890198 144.548157,265.780426 144.911133,265.835327 
	C145.000000,266.000000 144.500000,266.000000 144.250000,266.000000 
z"/>
<path fill="#FDFCFD" opacity="1.000000" stroke="none" 
	d="
M365.009460,190.002563 
	C363.861450,191.298645 362.713440,192.594711 361.036682,194.205658 
	C359.673309,194.685196 358.838715,194.849854 358.004120,195.014496 
	C334.979034,194.949890 311.953949,194.885269 288.088318,194.778046 
	C286.726685,194.621521 286.205597,194.507614 285.684479,194.393707 
	C284.549957,193.099808 283.415436,191.805893 282.089172,189.971390 
	C281.838959,172.630447 281.780518,155.830078 281.722076,139.029724 
	C283.342102,137.507492 284.962097,135.985260 287.251831,134.212433 
	C311.947449,133.975891 335.973297,133.989914 359.999176,134.003937 
	C361.500885,135.537613 363.002563,137.071304 364.776276,139.266815 
	C365.035370,156.619965 365.022400,173.311279 365.009460,190.002563 
z"/>
<path fill="#FBFAFC" opacity="1.000000" stroke="none" 
	d="
M179.955704,134.161133 
	C186.117630,139.517670 185.860580,147.819000 178.701706,152.396576 
	C132.518082,152.640518 87.031105,152.652008 41.544128,152.646683 
	C40.049629,152.646515 38.555145,152.475677 37.060654,152.384415 
	C29.877460,147.498428 29.665400,139.109833 37.272411,134.272751 
	C84.283157,133.947113 130.631790,133.916168 176.980408,133.900070 
	C177.972137,133.899734 178.963943,134.070297 179.955704,134.161133 
z"/>
<path fill="#F5F2F5" opacity="1.000000" stroke="none" 
	d="
M100.998077,189.988022 
	C92.588951,186.484894 91.120865,178.428284 98.323593,171.910187 
	C99.593826,171.412842 100.299828,171.219772 101.005829,171.026703 
	C111.020943,171.100128 121.036064,171.173553 131.860062,171.324142 
	C133.160828,171.494904 133.652710,171.588486 134.144592,171.682068 
	C140.839783,178.504929 139.694595,186.538467 130.835449,189.705719 
	C120.387550,189.862106 110.692818,189.925064 100.998077,189.988022 
z"/>
<path fill="#F5F3F5" opacity="1.000000" stroke="none" 
	d="
M37.977600,189.839981 
	C32.814907,187.847763 31.284664,183.877914 31.844290,178.709686 
	C32.338085,174.149399 34.964592,171.376587 39.618351,171.304779 
	C49.244537,171.156250 58.891697,170.944794 68.490707,171.474884 
	C70.838249,171.604507 74.152191,174.030228 75.062531,176.216217 
	C76.886665,180.596481 76.706200,185.379059 71.657669,188.968613 
	C70.731270,189.403931 70.333206,189.589935 69.935135,189.775925 
	C69.763863,189.744492 69.592583,189.713058 68.751083,189.740784 
	C58.046432,189.813293 48.012016,189.826645 37.977600,189.839981 
z"/>
<path fill="#342C3E" opacity="1.000000" stroke="none" 
	d="
M2.023092,109.014755 
	C2.018264,108.846481 2.013436,108.678200 2.003313,108.257500 
	C134.348175,108.004662 266.698334,108.004242 399.514709,108.013840 
	C397.914429,108.349342 395.847961,108.958969 393.781342,108.959702 
	C266.166351,109.004936 138.551376,109.000351 10.467609,109.001251 
	C7.957167,109.003242 5.915516,109.004349 3.192401,109.006332 
	C2.510937,109.007195 2.023092,109.014755 2.023092,109.014755 
z"/>
<path fill="#19151C" opacity="1.000000" stroke="none" 
	d="
M179.910950,133.828583 
	C178.963943,134.070297 177.972137,133.899734 176.980408,133.900070 
	C130.631790,133.916168 84.283157,133.947113 37.465488,133.982300 
	C37.001720,133.543976 37.006996,133.099731 37.475254,132.325821 
	C84.619484,131.990936 131.300735,131.985733 177.981979,131.980530 
	C178.610046,132.485687 179.238129,132.990860 179.910950,133.828583 
z"/>
<path fill="#1A171E" opacity="1.000000" stroke="none" 
	d="
M359.937225,133.683578 
	C335.973297,133.989914 311.947449,133.975891 287.451965,133.945831 
	C286.990753,133.490417 286.999176,133.051010 287.476654,132.295349 
	C311.284851,131.974442 334.623962,131.969788 357.963104,131.965134 
	C358.600494,132.431168 359.237885,132.897202 359.937225,133.683578 
z"/>
<path fill="#010004" opacity="1.000000" stroke="none" 
	d="
M37.160908,152.709290 
	C38.555145,152.475677 40.049629,152.646515 41.544128,152.646683 
	C87.031105,152.652008 132.518082,152.640518 178.469330,152.644363 
	C176.959259,153.095627 174.985626,153.913406 173.010483,153.917053 
	C128.642838,153.999069 84.275024,153.991623 39.206306,154.020508 
	C38.505379,154.039978 38.044231,154.091171 38.044231,154.091171 
	C37.783207,153.738831 37.522182,153.386505 37.160908,152.709290 
z"/>
<path fill="#39313C" opacity="1.000000" stroke="none" 
	d="
M177.685059,131.690796 
	C131.300735,131.985733 84.619484,131.990936 37.469803,131.992249 
	C38.398636,131.659119 39.795578,131.043716 41.193211,131.042130 
	C85.614647,130.991638 130.036148,130.998077 174.457642,131.017380 
	C175.434509,131.017807 176.411301,131.267609 177.685059,131.690796 
z"/>
<path fill="#161318" opacity="1.000000" stroke="none" 
	d="
M365.397217,189.887619 
	C365.022400,173.311279 365.035370,156.619965 365.045349,139.459076 
	C365.690216,139.963791 366.895050,140.933914 366.902435,141.913025 
	C367.017242,157.203598 366.992279,172.495392 366.922882,187.786575 
	C366.919861,188.450302 366.181030,189.110703 365.397217,189.887619 
z"/>
<path fill="#1E1821" opacity="1.000000" stroke="none" 
	d="
M281.356781,139.161957 
	C281.780518,155.830078 281.838959,172.630447 281.860779,189.866821 
	C281.218048,189.073929 280.094330,187.849121 280.084625,186.615524 
	C279.965851,171.546005 279.997375,156.475143 280.054443,141.404861 
	C280.057098,140.700134 280.665314,139.997696 281.356781,139.161957 
z"/>
<path fill="#3B353F" opacity="1.000000" stroke="none" 
	d="
M357.667114,131.678162 
	C334.623962,131.969788 311.284851,131.974442 287.478760,131.965302 
	C288.246216,131.634796 289.479950,131.045013 290.715118,131.041946 
	C312.290253,130.988205 333.865509,131.003036 355.440735,131.024872 
	C356.084351,131.025513 356.727661,131.263733 357.667114,131.678162 
z"/>
<path fill="#261F27" opacity="1.000000" stroke="none" 
	d="
M38.067993,190.246460 
	C48.012016,189.826645 58.046432,189.813293 68.541275,189.896362 
	C68.223572,190.655624 67.453613,191.883423 66.666069,191.894821 
	C57.793854,192.023056 48.918663,191.990982 40.045319,191.900024 
	C39.412144,191.893539 38.787170,191.087296 38.067993,190.246460 
z"/>
<path fill="#261F27" opacity="1.000000" stroke="none" 
	d="
M101.096405,190.382812 
	C110.692818,189.925064 120.387550,189.862106 130.541077,189.903625 
	C130.202454,190.665497 129.412598,191.883194 128.606461,191.894058 
	C119.967987,192.010529 111.326744,191.955124 102.687096,191.865845 
	C102.185944,191.860657 101.692024,191.156479 101.096405,190.382812 
z"/>
<path fill="#261F27" opacity="1.000000" stroke="none" 
	d="
M100.789352,170.757111 
	C100.299828,171.219772 99.593826,171.412842 98.524780,171.659943 
	C98.965454,171.305176 99.769157,170.896362 100.789352,170.757111 
z"/>
<path fill="#18101D" opacity="1.000000" stroke="none" 
	d="
M358.225220,195.294769 
	C358.838715,194.849854 359.673309,194.685196 360.937195,194.460297 
	C360.393066,194.791718 359.419708,195.183395 358.225220,195.294769 
z"/>
<path fill="#261F27" opacity="1.000000" stroke="none" 
	d="
M134.036346,171.364075 
	C133.652710,171.588486 133.160828,171.494904 132.322845,171.254410 
	C132.627182,171.087021 133.277634,171.066544 134.036346,171.364075 
z"/>
<path fill="#261F27" opacity="1.000000" stroke="none" 
	d="
M70.111603,190.044907 
	C70.333206,189.589935 70.731270,189.403931 71.464401,189.220795 
	C71.295670,189.587082 70.791878,189.950485 70.111603,190.044907 
z"/>
<path fill="#18101D" opacity="1.000000" stroke="none" 
	d="
M285.847168,194.691956 
	C286.205597,194.507614 286.726685,194.621521 287.626099,194.859573 
	C287.339569,194.985870 286.674744,194.988037 285.847168,194.691956 
z"/>
<path fill="#3B363D" opacity="1.000000" stroke="none" 
	d="
M38.129871,154.238098 
	C38.044231,154.091171 38.505379,154.039978 38.736656,154.053558 
	C38.717125,154.173096 38.466316,154.279053 38.129871,154.238098 
z"/>
<path fill="#3D273B" opacity="1.000000" stroke="none" 
	d="
M395.680542,55.681877 
	C266.302460,55.976555 136.626266,55.984013 6.483625,55.981865 
	C7.750960,55.648132 9.484647,55.040844 11.218546,55.040237 
	C137.795090,54.995941 264.371643,54.998417 390.948212,55.016075 
	C392.426300,55.016281 393.904327,55.263008 395.680542,55.681877 
z"/>
<path fill="#3D273B" opacity="1.000000" stroke="none" 
	d="
M399.873779,55.775982 
	C399.961151,55.925106 399.492310,55.965801 399.257355,55.961166 
	C399.277069,55.846638 399.531769,55.736748 399.873779,55.775982 
z"/>
<path fill="#3D273B" opacity="1.000000" stroke="none" 
	d="
M3.909804,55.829369 
	C3.995866,55.990410 3.507028,56.000931 3.263490,55.982697 
	C3.287882,55.865753 3.555812,55.767040 3.909804,55.829369 
z"/>
<path fill="#282432" opacity="1.000000" stroke="none" 
	d="
M2.014613,109.481857 
	C2.023092,109.014755 2.510937,109.007195 2.754867,109.009300 
	C2.999274,151.327011 3.004736,193.642624 2.983143,235.958206 
	C2.982219,237.769226 2.731174,239.580109 2.306849,241.688156 
	C2.013413,197.973160 2.009773,153.961060 2.014613,109.481857 
z"/>
<path fill="#342C3E" opacity="1.000000" stroke="none" 
	d="
M3.900132,248.830872 
	C3.672418,248.953110 3.416788,248.768646 3.155417,248.265930 
	C3.393202,248.145020 3.634048,248.337173 3.900132,248.830872 
z"/>
</svg>